import { createSlice } from "@reduxjs/toolkit";
import { initDeficiencyCommentList } from "../data/type";

export const deficiencyCommentSlice = createSlice({
    name: "deficiencyComment",
    initialState: initDeficiencyCommentList,
    reducers: {
        setDeficiencyComment: (state, action) => {
            return action.payload;
        },
        updateCell: (state, action) => {
            const objIndex = action.payload.id;
            state[objIndex] = {
                ...state[objIndex],
                comment: action.payload.comment,                     //コメント
                deficiency_status: action.payload.deficiency_status, //不備ステータス
                edit_status: action.payload.edit_status,             //編集の可否 trueが編集不可 falseが編集可
            };
        },
        updateCellSave: (state, action) => {
            const objIndex = action.payload.id;
            state[objIndex] = {
                ...state[objIndex],
                comment: action.payload.comment,                     //コメント
                init_comment: action.payload.comment,                //初期コメントを更新
                deficiency_status: action.payload.deficiency_status, //不備ステータス
                edit_status: action.payload.edit_status,             //編集の可否 trueが編集不可 falseが編集可
            };
        },
    },
});

export const {
    setDeficiencyComment,
    updateCell,
    updateCellSave
} = deficiencyCommentSlice.actions;
export default deficiencyCommentSlice.reducer;
